module.exports = __webpack_public_path__ + "static/img/warning_blue.4e17a00.svg";